import React from 'react'
import { BlogListing, Page } from 'components/organisms'

interface Props {
  pagina?: any
}

const BlogTemplate = (props: Props) => {
  const { pagina = null } = props

  return (
    <Page pagina={pagina} topBg="left" className="blog-template">
      <BlogListing />
    </Page>
  )
}

export default BlogTemplate
